import React, { useContext } from "react";
import { AuthContext } from "../contexts/AuthContext";
import { Navigate } from "react-router-dom";
import LoadingAction from "../themes/LoadingAction/LoadingAction";
import * as links from "../utils/links";

function PublicRoute({ children }) {
  const { authInfo, loading } = useContext(AuthContext);
  const { isAuthenticated, dataUser } = authInfo;

  if (loading) {
    return <LoadingAction />;
  }

  if (!isAuthenticated) {
    return children;
  }

  /* Usuário já autenticado que cair numa rota pública volta para a PRIMEIRA
     opção do menu. Em qualquer rota privada, atualizar a página mantém a
     própria rota atual, sem mandar para outra seção. */
  return (
    <Navigate
      to={
        dataUser?.key === "ADMIN"
          ? links.ADMIN_CENTRAL
          : links.CLIENTE_VISAO_GERAL
      }
      replace
    />
  );
}

export default PublicRoute;
